/**
 * Hide payment-method tiles the active (flow-set) currency excludes.
 *
 * `methodCurrencies` comes from `/v1/checkout/config` (constrained methods only;
 * manifest defaults narrowed by any tenant override). A tile is kept when there
 * is no currency yet (can't filter), no `methodCurrencies` map, the method has
 * no entry (unconstrained), or its list includes the currency.
 */
export function filterMethodsByCurrency<T extends { paymentMethod: string }>(
  tiles: T[],
  methodCurrencies: Record<string, string[]> | undefined,
  currency: string | undefined,
): T[] {
  if (!currency || !methodCurrencies) return tiles;
  return tiles.filter((t) => {
    const allowed = methodCurrencies[t.paymentMethod];
    return !allowed || allowed.includes(currency);
  });
}
